import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import IframeResizer from 'iframe-resizer-react';
import { useIntl } from 'react-intl';
import { Link, NavLink } from 'react-router';

import { routes } from '#routes/routes.ts';

import { config } from '../../config';
import ServiceInfo from './ServiceInfo';

const AppHeader = () => {
    const intl = useIntl();
    const environment = import.meta.env.PROD ? 'production' : 'local';

    const serviceInfoItem = <ServiceInfo />;
    const notifications = <RioNotifications />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;
    const navItems = [
        {
            key: 'tourservice',
            route: (
                <NavLink to={routes.TOURSERVICE} viewTransition>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.tours.title',
                        defaultMessage: 'Tours',
                    })}
                </NavLink>
            ),
        },
    ];

    return (
        <ApplicationHeader
            label='Order Communication Web'
            appNavigator={<IframeResizer className='iFrameResizer' src={config.backend.MENU_SERVICE} />}
            homeRoute={<Link to={config.homeRoute || ''} />}
            navItems={navItems}
            actionBarItems={[serviceInfoItem, notifications, userMenuItem]}
        />
    );
};

export default AppHeader;
